import Breadcrumb from 'components/commercetools-ui/atoms/breadcrumb';
import React, { useState, useEffect, useRef } from 'react';
import useMediaQuery from 'helpers/hooks/useMediaQuery';
import { mediumDesktop, mobile, tablet } from 'helpers/utils/screensizes';
import Button from 'components/commercetools-ui/atoms/button';
import Typography from 'components/commercetools-ui/atoms/typography';
import Input from 'components/commercetools-ui/atoms/input';
import { useFormat } from 'helpers/hooks/useFormat';
import dynamic from 'next/dynamic';
import {
  Caroma_Brands,
  Source_Site,
} from 'helpers/constants/contactUs';
import { sdk } from 'sdk';
import ReCAPTCHA from 'react-google-recaptcha';
import { RECAPTCHA_SITE_KEY } from 'helpers/constants/googleAnalytics';
import Modal from 'components/commercetools-ui/atoms/modal';
import { useParams, usePathname } from 'next/navigation';
import { HomeIcon } from '@heroicons/react/24/outline';
import { ChevronRightIcon } from '@heroicons/react/24/solid';
import Link from 'components/commercetools-ui/atoms/link';
import useTranslation from 'providers/i18n/hooks/useTranslation';
import Dropdown from 'components/commercetools-ui/atoms/dropdown';

const Markdown = dynamic(() => import('../../organisms/markdown'));

export type WarrantyRegistrationProps = {
    data?: any;
};

interface WarrantyRegistrationFormData {
    First_Name: string,
    Last_Name: string,
    Email: string,
    Street_Address: string,
    Town: string,
    Postcode: string,
    Store_Purchased_From: string,
    Product_Code: string,
    Brand: string;
    Date_Purchased: string,
    Source_Site: string,
    AttachmentType: string;
    DocumentBase64: any;
}


const WarrantyRegistrationSlider = ({ data }: React.PropsWithChildren<WarrantyRegistrationProps>) => {

    const [isDesktopSize] = useMediaQuery(mediumDesktop);
    const [isTabletSize] = useMediaQuery(tablet);
    const { formatMessage } = useFormat({ name: 'common' });
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [collectionStatementChecked, setCollectionStatementChecked] = useState(false);
    const isLargeScreen = useMediaQuery(mobile);
    const [error, setError] = useState<string | null>(null);
    const fileInputRef = useRef<HTMLInputElement>(null);
    const [fileErrorMessage, setFileErrorMesage] = useState('');
    const { translate } = useTranslation();
    const [clearDropdowns, setClearDropdowns] = useState(false);
    const today = new Date().toISOString().split('T')[0];

    const [formData, setFormData] = useState<WarrantyRegistrationFormData>({
        First_Name: '',
        Last_Name: '',
        Email: '',
        Street_Address: '',
        Town: '',
        Postcode: '',
        Store_Purchased_From: '',
        Product_Code: '',
        Brand:'',
        Date_Purchased: '',
        Source_Site: '',
        AttachmentType: '',
        DocumentBase64: '',
      });

      const [validationErrors, setValidationErrors] = useState({
        firstName: false,
        lastName: false,
        email: '',
        streetAddress: false,
        storePurchasedFrom: false,
        productCode: false,
        postcode: false,
        datePurchased: false,
        checkbox: false,
        AttachmentType: '',
        enquiry: false,
      });

      const [fileInputKey, setFileInputKey] = useState(0);
      const [success, setSuccess] = useState('');
      const { locale } = useParams();
      const [reCaptchaError, setReCaptchaError] = useState('');
      const [hasError, setHasError] = useState(true);
      const recaptchaRef = useRef<ReCAPTCHA>(null);
      const onChangeRecaptcha = (e: any) => {
           // on captcha change
           if(reCaptchaError && e){
               setReCaptchaError('')
           }
      };
      const extensions = sdk.composableCommerce;


      //Handle Validation
      //==========================
      const handleValidations = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setHasError(false);

        if (!formData.AttachmentType) {
            setValidationErrors((prevErrors) => ({ ...prevErrors, AttachmentType: 'Please attach a file.' }));
            setHasError(true);
          } else {
            setValidationErrors((prevErrors) => ({ ...prevErrors, AttachmentType: '' }));
        }       

        if (!formData.First_Name) {
          setValidationErrors((prevErrors) => ({ ...prevErrors, firstName: true }));
          //   hasError = true;
          setHasError(true);
        } else {
          setValidationErrors((prevErrors) => ({ ...prevErrors, firstName: false }));
        }        

        if (!formData.Last_Name) {
            setValidationErrors((prevErrors) => ({ ...prevErrors, lastName: true }));
            //   hasError = true;
            setHasError(true);
        } else {
            setValidationErrors((prevErrors) => ({ ...prevErrors, lastName: false }));
        }

        if (!formData.Street_Address) {
            setValidationErrors((prevErrors) => ({ ...prevErrors, streetAddress: true }));
            //   hasError = true;
            setHasError(true);
        } else {
            setValidationErrors((prevErrors) => ({ ...prevErrors, streetAddress: false }));
        }

        if (!formData.Postcode) {
          setValidationErrors((prevErrors) => ({ ...prevErrors, postcode: true }));
            //   hasError = true;
            setHasError(true);
        } else {
            setValidationErrors((prevErrors) => ({ ...prevErrors, postcode: false }));
        }

        if (!formData.Store_Purchased_From) {
            setValidationErrors((prevErrors) => ({ ...prevErrors, storePurchasedFrom: true }));
            //   hasError = true;
            setHasError(true);
        } else {
            setValidationErrors((prevErrors) => ({ ...prevErrors, storePurchasedFrom: false }));
        }

        if (!formData.Date_Purchased) {
            setValidationErrors((prevErrors) => ({ ...prevErrors, datePurchased: true }));
            //   hasError = true;
            setHasError(true);
          } else {
            setValidationErrors((prevErrors) => ({ ...prevErrors, datePurchased: false }));
        }    

        if (!formData.Product_Code) {
            setValidationErrors((prevErrors) => ({ ...prevErrors, productCode: true }));
            //   hasError = true;
            setHasError(true);
        } else {
            setValidationErrors((prevErrors) => ({ ...prevErrors, productCode: false }));
        }
        
        if (!formData.Brand) {
          setValidationErrors((prevErrors) => ({ ...prevErrors, enquiry: true }));
          //   hasError = true;
          setHasError(true);
        } else {
          setValidationErrors((prevErrors) => ({ ...prevErrors, enquiry: false }));
        }

        if (!collectionStatementChecked) {
          setValidationErrors((prevErrors) => ({ ...prevErrors, checkbox: true }));
          //   hasError = true;
          setHasError(true);
        } else {
          setValidationErrors((prevErrors) => ({ ...prevErrors, checkbox: false }));
        }

        const emailPattern =
          /^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
        if (!formData.Email) {
          setValidationErrors((prevErrors) => ({
            ...prevErrors,
            email: 'Email is required.',
          }));
          setHasError(true);
        } else if (!emailPattern.test(formData.Email)) {
          setValidationErrors((prevErrors) => ({
            ...prevErrors,
            email: 'Please enter a valid email address.',
          }));
          setHasError(true);
        } else {
          setValidationErrors((prevErrors) => ({ ...prevErrors, email: '' }));
        }
        
        if (locale) {
          setFormData((prevFormData) => ({
            ...prevFormData,
            Country: locale.toUpperCase(),
          }));
        }
    
        if (locale) {
          setFormData((prevFormData) => ({
            ...prevFormData,
            Source_Site: Source_Site,
          }));
        }    
      };


      const handleFileChange = (event: any) => {
        const file = event.target.files[0];        
        if (file) {
          const fileSizeInMB = file.size / (1024 * 1024);
          if (fileSizeInMB > 5) {
            setFileErrorMesage(translate('File should be less then 5 MB'));
          } else {
            setFileErrorMesage('');
          }
          const name = file?.name.split('.')[0];
          const type = file?.type.split('/')[1];
          const reader = new FileReader();
          reader.onloadend = () => {
            const data = reader as any;
            const base64 = data.result.split(',')[1];
            setFormData((prev) => {
              return {
                ...prev,
                FileName: name,
                AttachmentType: type,
                DocumentBase64: base64,
              };
            });
          };
          reader.readAsDataURL(file);
        }
      else
        {
          setFormData((prev) => ({...prev,FileName: '',AttachmentType: '',DocumentBase64: ''}));
        }
      };



      useEffect(() => {
        if (!hasError) {
          handleAPICall();
        }
      }, [hasError, handleValidations]);


      const handleAPICall = async () => {
        if (!hasError) {
            setHasError(true);
            try {
              const recaptchaValue = recaptchaRef.current?.getValue();

              if (formData.Date_Purchased && !formData.Date_Purchased.includes('T')) {
                formData.Date_Purchased = `${formData.Date_Purchased}T00:00:00Z`;
              }

              const response = await extensions.product.submitWarrantyInformationForm({ formData, recaptchaValue });
      
              if (!recaptchaValue) {
                setError('');
                setSuccess('');
                setReCaptchaError('reCaptcha verification failed. Please try again');
                return;
              }
      
              //When error exists in message then we will throw an error
              if (response.error && response.error.message === "Error") {
                setReCaptchaError('');
                setError('');
                setSuccess('');
                setError(
                  formatMessage({
                    id: 'query.error',
                    defaultMessage: 'We are experiencing technical issues. Please try again later.',
                }),)
                return;
              }
              else if (!response.isError) {
                setError('');
                setReCaptchaError('');
                setSuccess(
                  formatMessage({
                    id: 'query.submitted',
                    defaultMessage: 'Your query has been submitted.',
                  }),
                );
                setFormData({
                    First_Name: '',
                    Last_Name: '',
                    Email: '',
                    Street_Address: '',
                    Town: '',
                    Postcode: '',
                    Store_Purchased_From: '',
                    Product_Code: '',
                    Brand: '',
                    Date_Purchased: '',
                    Source_Site: '',
                    AttachmentType: '',
                    DocumentBase64: '',
                });

                setFileInputKey(prevKey => prevKey + 1);
                setFormData((prev) => ({ ...prev, FileName: '', AttachmentType: '', DocumentBase64: '' }));
                setValidationErrors((prevErrors) => ({...prevErrors,AttachmentType: ''}));
                setFileErrorMesage('');

                setCollectionStatementChecked(false);
                setClearDropdowns(true);
                recaptchaRef.current?.reset()
              } else {
                setReCaptchaError('');
                setError('');
                setSuccess('');
                //setReCaptchaError('reCaptcha verification failed. Please try again');
                setError(
                  formatMessage({
                    id: 'query.error',
                    defaultMessage: 'We are experiencing technical issues. Please try again later.',
                }),)
              }  
            } catch (error) {
                setError(
                  formatMessage({
                    id: 'query.error',
                    defaultMessage: 'We are experiencing technical issues. Please try again later.',
                  }),)
            }
          }
        };



        const updateData = (name: string, value: string) => {
            setFormData((prevData) => ({ ...prevData, [name]: value }));
            // Clear error messages for inputs on change

            if (name === 'First_Name') {
              setValidationErrors((prevErrors) => ({ ...prevErrors, firstName: false }));
            }

            if (name === 'Last_Name') {
              setValidationErrors((prevErrors) => ({ ...prevErrors, lastName: false }));
            }

            if (name === 'Street_Address') {
              setValidationErrors((prevErrors) => ({ ...prevErrors, streetAddress: false }));
            }

            if (name === 'Postcode') {
              setValidationErrors((prevErrors) => ({ ...prevErrors, postcode: false }));
            }

            if (name === 'Store_Purchased_From') {
                setValidationErrors((prevErrors) => ({ ...prevErrors, storePurchasedFrom: false }));
            }

            if (name === 'Product_Code') {
                setValidationErrors((prevErrors) => ({ ...prevErrors, productCode: false }));
            }

            if (name === 'Brand') {
              setValidationErrors((prevErrors) => ({ ...prevErrors, enquiry: false }));
            }

            if (name === 'Date_Purchased') {
                setValidationErrors((prevErrors) => ({ ...prevErrors, datePurchased: false }));
            }

            if (name === 'Checkbox') {
              setValidationErrors((prevErrors) => ({ ...prevErrors, firstName: false }));
            }
        };
        const currentURL = usePathname();
        const isWarrantyPage = currentURL.includes('/warranty-registration');

        const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
            setClearDropdowns(false);
            updateData(e.target.name, e.target.value);
        };

        type OptionType = {
          value: string | number;
          label: string;
        };

        const handleEnquirySelectChange = (option: { value: string | number }): void => {
          setFormData((prevData) => ({
            ...prevData,
            Brand: option.value.toString(),
          }));
          updateData('Brand', option.value.toString());
        };

        const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            const isChecked = e.target.checked;
            setCollectionStatementChecked(isChecked);
            // Clear the error if the checkbox is checked
            if (isChecked) {
              setValidationErrors((prevErrors) => ({
                ...prevErrors,
                checkbox: false,
              }));
            }
        };

        const openModal = () => setIsModalOpen(true);
        const closeModal = () => setIsModalOpen(false);





    type Section = {
        section_with_heading_description?: {
          title?: string;
          description?: string;
        };
      };
      
      const getSectionData = (title: string): string => {
        return (
          data?.sections?.find(
            (section: Section) => 
              section.section_with_heading_description?.title === title
          )?.section_with_heading_description?.description || ''
        );
      };
      
      // Usage
      const warrantydetails = getSectionData('Warranty Registration');
      const sendUsMessage = getSectionData('Send us a message');
      const PopupCollectionStatement = getSectionData('Collection Statement');
      

      return (
        <>

            {isWarrantyPage && (
                <div className="hidden px-24 pb-8 pt-16 md:block md:px-12 lg:px-32 xl:px-44 2xl:px-64">
                <Breadcrumb Separator={<ChevronRightIcon className="mt-2 w-16" />} listClassName="!gap-x-16">
                    <Link link={'/'}>
                    <HomeIcon className="mt-6 w-20" />
                    </Link>
                    <span className="text-14 font-normal leading-4 text-[#666]">Warranty Registration</span>
                </Breadcrumb>
                </div>
            )}


            <div
                className={`${
                isTabletSize
                    ? 'mb-50 flex min-h-[45rem] gap-80 px-24 lg:px-48 xl:gap-40 xl:px-60 2xl:gap-80 2xl:px-80 '
                    : 'flex flex-col'
                } ${isDesktopSize ? 'flex-row-reverse' : 'flex-col-reverse'} ${
                data?.mobile_image_alignment === 'Top' ? 'flex-col' : ''
                }`}
            >


                <form
                    onSubmit={handleValidations}
                    noValidate
                    className="flex flex-1 flex-col gap-15 px-24 py-33 md:gap-15 md:px-28 md:py-33 xl:gap-15 xl:px-36 xl:py-40 2xl:gap-16 2xl:px-64 2xl:py-80"
                >

                    {/* Title of Form */}
                    <Typography as="h1" className="pb-20 text-32 font-medium leading-10 text-black xl:text-34 2xl:text-48">
                        {formatMessage({ id: 'Register your new product', defaultMessage: 'Register your new product' })}
                    </Typography>



                    {/* First Name */}
                    <Input
                        label={'First Name'}
                        type="text"
                        required
                        name="First_Name"
                        maxLength={50}
                        onChange={(e) => {
                        handleChange(e);
                        setValidationErrors((prevErrors) => ({ ...prevErrors, firstName: false }));
                        }}
                        placeholder={`${formatMessage({
                        id: 'first.name',
                        defaultMessage: 'Name',
                        })}`}
                        value={formData.First_Name}
                        autoComplete=""
                        className="border-1 rounded !border-[#747474] !text-16 !text-black placeholder:text-black"
                    />
                    {validationErrors.firstName && (
                        <span className="pl-5 text-16 text-red-600" id="firstNameError">
                        {formatMessage({
                            id: 'first.name.invalid',
                            defaultMessage: 'First name is required.',
                        })}
                        </span>
                    )}


                    {/* Last Name */}
                    <Input
                        label={'Last Name'}
                        type="text"
                        required
                        name="Last_Name"
                        maxLength={50}
                        onChange={(e) => {
                        handleChange(e);
                        setValidationErrors((prevErrors) => ({ ...prevErrors, lastName: false }));
                        }}
                        placeholder={`${formatMessage({
                        id: 'last.name',
                        defaultMessage: 'Last Name',
                        })}`}
                        value={formData.Last_Name}
                        autoComplete=""
                        className="border-1 rounded !border-[#747474] !text-16 !text-black placeholder:text-black"
                    />
                    {validationErrors.lastName && (
                        <span className="pl-5 text-16 text-red-600" id="lastNameError">
                        {formatMessage({
                            id: 'last.name.invalid',
                            defaultMessage: 'Last name is required.',
                        })}
                        </span>
                    )}


                    {/* Email */}
                    <Input
                        label={'Email'}
                        name="Email"
                        required
                        pattern="^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$"
                        title="Please enter a valid email address."
                        type="email"
                        onChange={(e) => {
                        handleChange(e);
                        setValidationErrors((prevErrors) => ({ ...prevErrors, email: '' }));
                        }}
                        placeholder={formatMessage({ id: 'email.address', defaultMessage: 'Email Address' })}
                        value={formData.Email}
                        autoComplete=""
                        maxLength={100}
                        className="border-1 relative rounded !border-[#747474] !text-16 !text-black placeholder:text-black"
                    />
                    {validationErrors.email && (
                        <span className="pl-5 text-16 text-red-600" id="emailError">
                        {validationErrors.email}
                        </span>
                    )}


                    {/* Street_Address */}
                    <Input
                        label={'Address'}
                        type="text"
                        required
                        name="Street_Address"
                        maxLength={50}
                        onChange={(e) => {
                            handleChange(e);
                            setValidationErrors((prevErrors) => ({ ...prevErrors, streetAddress: false }));
                        }}
                        placeholder={`${formatMessage({
                        id: 'address',
                        defaultMessage: 'Address',
                        })}`}
                        value={formData.Street_Address}
                        autoComplete=""
                        className="border-1 rounded !border-[#747474] !text-16 !text-black placeholder:text-black"
                    />
                    {validationErrors.streetAddress && (
                        <span className="pl-5 text-16 text-red-600" id="addressError">
                        {formatMessage({
                            id: 'address.invalid',
                            defaultMessage: 'Address is required.',
                        })}
                        </span>
                    )}


                    {/* Town */}
                    <Input
                        label={'Town'}
                        type="text"
                        name="Town"
                        onChange={handleChange}
                        placeholder="Street Address"
                        value={formData.Town}
                        maxLength={50}
                        autoComplete=""
                        className="border-1 rounded !border-[#747474] !text-16 !text-black placeholder:text-black"
                    />


                    {/* Postcode */}
                    <Input
                        label={'Postcode'}
                        type="text"
                        required
                        name="Postcode"
                        onChange={handleChange}
                        placeholder="Postcode"
                        value={formData.Postcode}
                        maxLength={5}
                        autoComplete=""
                        className="border-1 rounded !border-[#747474] !text-16 !text-black placeholder:text-black"
                    />
                    {validationErrors.postcode && (
                        <span className="pl-5 text-16 text-red-600" id="addressError">
                        {formatMessage({
                            id: 'postcode.invalid',
                            defaultMessage: 'Postcode is required.',
                        })}
                        </span>
                    )}


                    {/* Date Purchased */}
                    <Input
                        label={'Date Purchased'}
                        type="date"
                        required
                        name="Date_Purchased"
                        onChange={(e) => {
                            handleChange(e);
                            setValidationErrors((prevErrors) => ({ ...prevErrors, datePurchased: false }));
                        }}
                        placeholder="Postcode"
                        max={today}
                        value={formData.Date_Purchased}
                        maxLength={250}
                        autoComplete="off"
                        className="border-1 rounded !border-[#747474] !text-16 !text-black placeholder:text-black"
                        onKeyDown={(e) => e.preventDefault()} // Prevents manual typing
                    />
                    {validationErrors.datePurchased && (
                        <span className="pl-5 text-16 text-red-600" id="datePurchasedError">
                        {formatMessage({
                            id: 'datePurchased.invalid',
                            defaultMessage: 'Please select date.',
                        })}
                        </span>
                    )}



                    {/* Store_Purchased_From */}
                    <Input
                        label={'Store Purchased From'}
                        type="text"
                        required
                        name="Store_Purchased_From"
                        maxLength={50}
                        onChange={(e) => {
                        handleChange(e);
                        setValidationErrors((prevErrors) => ({ ...prevErrors, storePurchasedFrom: false }));
                        }}
                        placeholder={`${formatMessage({
                        id: 'storePurchasedFrom',
                        defaultMessage: 'Store Purchased From',
                        })}`}
                        value={formData.Store_Purchased_From}
                        autoComplete=""
                        className="border-1 rounded !border-[#747474] !text-16 !text-black placeholder:text-black"
                    />
                    {validationErrors.storePurchasedFrom && (
                        <span className="pl-5 text-16 text-red-600" id="storePurchasedFromError">
                        {formatMessage({
                            id: 'storePurchasedFrom.invalid',
                            defaultMessage: 'Store purchased from is required.',
                        })}
                        </span>
                    )}


                    {/* Product_Code */}
                    <Input
                        label={'Product Code'}
                        type="text"
                        required
                        name="Product_Code"
                        maxLength={50}
                        onChange={(e) => {
                        handleChange(e);
                        setValidationErrors((prevErrors) => ({ ...prevErrors, productCode: false }));
                        }}
                        placeholder={`${formatMessage({
                        id: 'productCode',
                        defaultMessage: 'Product Code',
                        })}`}
                        value={formData.Product_Code}
                        autoComplete=""
                        className="border-1 rounded !border-[#747474] !text-16 !text-black placeholder:text-black"
                    />
                    {validationErrors.productCode && (
                        <span className="pl-5 text-16 text-red-600" id="productCodeError">
                        {formatMessage({
                            id: 'productCode.invalid',
                            defaultMessage: 'Product code is required.',
                        })}
                        </span>
                    )}


                      <Dropdown
                       label={'Brand'}
                       selectOptions={Caroma_Brands}
                       selectOnChange={handleEnquirySelectChange}
                       disableFirstOption={true}
                       clearDropdown={clearDropdowns}
                       required
                       selectDropdownClassNames="!text-16 !text-black text-left border-dim-gray overflow-hidden !h-fit !py-8 w-full"
                       ></Dropdown>
                     {validationErrors.enquiry && (
                       <span className="pl-5 text-16 text-red-600" id="enquiryError">
                         {formatMessage({
                           id: 'brand.required',
                           defaultMessage: 'Brand is required.',
                         })}
                       </span>
                     )}


                    {/* File Upload */}
                    <div>                        
                        <Input
                            key={fileInputKey}
                            label={'In order to validate your warranty if required, we will need a copy of your receipt. Load a photo of it here for safe keeping'}
                            ref={fileInputRef}
                            type="file"
                            required
                            name="files"
                            //onChange={handleFileChange}
                            onChange={(e) => {
                              const file = e.target.files?.[0];
                              if (!file) {
                                // No file selected
                                setValidationErrors((prevErrors) => ({...prevErrors,AttachmentType: 'Please attach a file.'}));
                                setFormData((prev) => ({ ...prev, FileName: '', AttachmentType: '', DocumentBase64: '' }));
                                setFileErrorMesage('');
                                return;
                              }

                              if (file.type !== 'image/jpeg' && file.type !== 'image/jpg') {
                                // Wrong file type
                                setFormData((prev) => ({...prev,AttachmentType: ''}));
                                setValidationErrors((prevErrors) => ({...prevErrors,AttachmentType: 'Only Jpeg/jpg files are allowed.'}));
                                setFileErrorMesage('');
                                e.target.value = ''; // Clear the file input
                                return;
                              }

                              // Valid JPEG file
                              setValidationErrors((prevErrors) => ({...prevErrors,AttachmentType: ''}));
                              setFileErrorMesage('');

                              handleFileChange(e); // Call file reading function properly
                            }}
                            className=" !text-14 placeholder:text-[#666666] p-20"
                            accept=".jpeg,.jpg"
                        />
                        
                        {fileErrorMessage && (
                            <>
                                <span className="text-14 text-red-600">{fileErrorMessage}</span> <br />
                            </>
                        )}
                        {validationErrors.AttachmentType && (
                            <span className="pl-5 text-16 text-red-600" id="attachmentType">
                            {validationErrors.AttachmentType}
                            <br />
                            </span>
                        )}
                        <span className="pt-1 pl-5 text-sm text-[#666666] ">{translate('(Only Jpeg/jpg file accepted)')}</span>
                    </div>



                    {/* Privacy Consent */}
                    <div className="">
                        <label className="text-16 font-medium tracking-wide text-secondary-black">
                        {formatMessage({
                            id: 'privacy.consent',
                            defaultMessage: 'Privacy consent',
                        })}
                        <span className="!text-red-500"> * </span>
                        </label>
                        <div className="flex items-baseline gap-16">
                        <Input
                            // label={"Consent"}
                            type="checkbox"
                            name="checkbox"
                            required
                            className="!h-18 !w-18 !p-0"
                            checked={collectionStatementChecked}
                            onChange={handleCheckboxChange}
                        />
                        <Markdown
                            markdown={sendUsMessage}
                            className="!text-16 !leading-6 !text-black [&>p>a]:!text-[#337ab7]"
                            onCollectionLinkClick={openModal}
                        />
                        </div>
                    </div>

                    {validationErrors.checkbox && (
                        <span className="inline-block pl-5 text-16 text-red-600" id="checkboxError">
                        {formatMessage({
                            id: 'please.check',
                            defaultMessage: 'Please check the box if you want to proceed',
                        })}
                        </span>
                    )}


                    {/* Re - Captcha */}
                    <ReCAPTCHA ref={recaptchaRef} sitekey={`${RECAPTCHA_SITE_KEY}`} onChange={onChangeRecaptcha}        />
                    {success && (
                        <div>
                        <span className="text-16 text-green-600">{success}</span>
                        </div>
                    )}
                    {/* Added error message if API failed */}
                    {error && (
                        <div>
                        <span className="text-16 text-red-600">{error}</span>
                        </div>
                    )}
                    {reCaptchaError && (
                        <div>
                        <span className="text-16 text-red-600">{reCaptchaError}</span>
                        </div>
                    )}


                    {/* Submit Button */}
                    <Button
                        type="submit"
                        className="border-1 w-full rounded-none border border-[#2B2C39] bg-white px-18 py-10 shadow-sm hover:!border-[#F4F4F4] hover:!bg-[#F4F4F4] md:w-fit md:px-32 md:py-18"
                    >
                        <Typography as="span" className="text-18 text-[#090909]">
                        {formatMessage({ id: 'submit', defaultMessage: 'Submit' })}
                        </Typography>
                    </Button>
                    
                </form>
                


                {/* When click privacy consent and popup display */}
                {isModalOpen && (
                    <Modal
                        isOpen={isModalOpen}
                        onRequestClose={closeModal}
                        preventScroll={true}
                        style={{
                        content: {
                            backgroundColor: 'white',
                            padding: isLargeScreen ? '60px 40px 10px 40px' : '40px 20px 10px 40px',
                            overflow: 'hidden',
                        },
                        }}
                        closeButton
                        className='border-transparent focus:border-transparent focus:ring-0 focus:outline-none'
                        closeTimeoutMS={200}
                    >
                        <div style={{ maxHeight: 'calc(100vh - 250px)', overflowY: 'auto', overflowX: 'hidden' }} className="modal-height p-4">
                        <Markdown
                            markdown={PopupCollectionStatement}
                            className="markdown-content [&>div>div>p>a]:!text-[#337ab7]"
                        />
                        </div>
                    </Modal>
                )}


                    


                <div className="flex flex-1 flex-wrap items-center justify-center bg-[#F7F7F7] px-60 py-80 text-center xl:px-30 xl:py-40 2xl:px-60 2xl:py-40">
                    {warrantydetails && (
                        <Markdown markdown={warrantydetails} className="pb-32 text-23 font-medium text-black xl:pb-24 xl:text-23 2xl:pb-32 2xl:text-23" /> 
                    )}
                </div>


            </div>
        </>
      );

};

export default WarrantyRegistrationSlider;

